<template>
  <div id="simple-calendar-app">
    <ASpin :spinning="loading" :indicator="indicator">
        <div class="vx-card no-scroll-content">
          <calendar-view
            ref="calendar"
            displayWeekNumbers
            :displayPeriodUom="calendarView"
            :time-format-options="{ hour: 'numeric', minute: '2-digit' }"
            :show-times="true"
            current-period-label="icons"
            :enable-date-selection="true"
            :show-date="showDate"
            :doEmitItemMouseEvents="true"
            :events="calenders"
            enableDragDrop
            :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
            eventBorderHeight="0px"
            eventContentHeight="1.65rem"
            class="theme-default"
            @click-date="onCalendarCellClicked"
            @drop-on-date="eventDragged"
            :periodChangedCallback="periodChangedCallback"
          >
<!--            @click-event="openEditEvent"-->
              <template slot="header">
<!--                <div class="vx-row no-gutter mb-16">-->
<!--                  <div>-->
<!--                    -->
<!--                  </div>-->
<!--                </div>-->

                <!-- TOP ROW -->
                <div class="vx-row no-gutter mb-4">

                  <!-- BUTTONS -->
                  <div class="vx-col w-full md:w-1/2 xl:w-3/5 3xl:w-1/3 mb-4 lg:mb-0 items-center flex flex-row flex-nowrap lg:flex-row justify-center md:justify-start items-center">
                    <div class="p-2 flex justify-between items-center gap-x-1 lg:gap-x-4">
                      <feather-icon
                        :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                        @click="updateMonth(-1)"
                        svgClasses="w-5 h-5"
                        class="cursor-pointer text-primary"
                      />
                      <a-month-picker @change="onSelectedDateChanged">
                        <!--                      <div-->
                        <!--                        class="border rounded border-grey border-solid"-->
                        <!--                        style="width: 10rem;"-->
                        <!--                      >-->
                        <span class="cursor-pointer text-primary text-sm lg:text-base" style="text-wrap: nowrap;">{{showDate | month}}</span>
                        <!--                        <feather-icon icon="CalendarIcon" svg-classes="text-grey w-4 h-4"></feather-icon>-->
                        <!--                      </div>-->
                      </a-month-picker>
                      <feather-icon
                        :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                        @click="updateMonth(1)"
                        svgClasses="w-5 h-5"
                        class="cursor-pointer text-primary"
                      />
                    </div>
                    <a-radio-group v-model="calendarFilter" class="lg:mx-6">
                      <a-radio-button value="events" @click="fetchCalendar">
                        <span class="inline-flex items-center gap-x-1 text-sm lg:text-base">
                          <feather-icon icon="CalendarIcon" svg-classes="text-grey w-4 h-4"></feather-icon>
                          Events
                        </span>
                      </a-radio-button>
                      <a-radio-button value="tasks" @click="fetchCalendar">
                        <span class="inline-flex items-center gap-x-1 text-sm lg:text-base">
                          <feather-icon icon="CheckSquareIcon" svg-classes="text-grey w-4 h-4"></feather-icon>
                          Tasks
                        </span>
                      </a-radio-button>
                      <a-radio-button value="both" @click="fetchCalendar" class="text-sm lg:text-base fix-padding-trick">
                        All
                      </a-radio-button>
                    </a-radio-group>
                  </div> <!-- END BUTTONS -->

                  <!-- DATE SELECTION -->
                  <div class="vx-col w-1/2 md:w-full xl:w-1/5 3xl:w-1/3 sm:my-0 my-3 flex sm:justify-end justify-center order-last">
                    <a-button
                      v-if="hasPermission('calendar.event.create')"
                      type="primary"
                      icon="plus"
                      @click="openAddNewEvent(new Date())"
                      class="text-sm lg:text-base"
                      style="border-radius: 3px !important;"
                    >
                      Add event
                    </a-button>
<!--                    <div class="flex items-center">-->
<!--                      <feather-icon-->
<!--                        :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"-->
<!--                        @click="updateMonth(-1)"-->
<!--                        svgClasses="w-6 h-6 m-1"-->
<!--                        class="cursor-pointer bg-primary text-white rounded-full" />-->

<!--                      <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>-->

<!--                      <feather-icon-->
<!--                        :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"-->
<!--                        @click="updateMonth(1)"-->
<!--                        svgClasses="w-6 h-6 m-1"-->
<!--                        class="cursor-pointer bg-primary text-white rounded-full" />-->
<!--                    </div>-->
                  </div> <!-- END DATE SELECTION -->

                  <!-- CALENDAR VIEW SELECTION -->
                  <div class="vx-col w-1/2 xl:w-1/5 3xl:w-1/3 flex justify-center items-center">
                    <template v-for="(view, index) in calendarViewTypes">
                      <a-button
                        v-if="calendarView === view.val"
                        :key="String(view.val) + 'filled'"
                        type="primary"
                        class="p-1 px-2 md:px-8 text-sm lg:text-base"
                        :class="{'rounded-l-none': index > 0, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                        @click="calendarView = view.val"
                        ghost
                      >{{ view.label }}</a-button>
                      <a-button
                        v-else
                        :key="String(view.val) + 'border'"
                        type="border"
                        class="p-1 px-2 md:px-8 !rounded-[3px] text-sm lg:text-base"
                        :class="{'rounded-l-none': index > 0, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                        @click="calendarView = view.val"
                      >{{ view.label }}</a-button>
                    </template>
                  </div> <!-- END CALENDAR VIEW SELECTION -->
                </div> <!-- END TOP ROW -->

                <!-- SECOND ROW -->
                <div v-if="false" class="vx-row sm:flex hidden mt-4">
                  <div class="vx-col w-full flex">
                    <!-- LABELS -->
                    <div class="flex flex-wrap sm:justify-start justify-center">
                      <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                        <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                        <span>{{ label.text }}</span>
                      </div>
                      <div class="flex items-center mr-4 mb-2">
                        <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>
                        <span>None</span>
                      </div>
                    </div> <!-- END LABELS -->
                  </div>
                </div> <!-- END SECOND ROW -->
              </template>

              <template slot="event" slot-scope="{top,value,event:{title,classes,startDate,endDate,id,originalEvent}}">
                <div v-if="originalEvent.itemType === 'task'" class="cv-event flex items-center gap-x-2" :class="classes" :style="{top:top}" @click="showTaskList(startDate)">
                  <feather-icon icon="CheckSquareIcon" svg-classes="text-primary w-4 h-4"></feather-icon>
                  {{ title }}
                </div>
                <template v-else-if="originalEvent.itemType === 'event' && hasPermission('calendar.event.get')">
                  <a-popover
                    @visibleChange="(visibility)=> handleVisibilityChange(visibility,id)"
                    trigger="click"
                    overlayClassName="popover-event"
                    :overlayStyle="{ maxWidth:'350px',zIndex:'1' }"
                    placement="bottomLeft"
                  >
                    <template v-if="row_popover" slot="title">
                      <div :class="`bg-calender-${labelColor(row_popover.label)}`" class="p-3 rounded" style="color: white">
                        {{ row_popover.title || '--' }}
                      </div>
                    </template>
                    <template slot="content">
                      <ASpin :spinning="loading_popover" :indicator="indicator">
                        <template v-if="row_popover">
                          <a-descriptions colon :column="2">
                            <a-descriptions-item label="Start">
                              {{ setDateFormat(row_popover.start) || '-' }}
                            </a-descriptions-item>
                            <a-descriptions-item label="End">
                              {{ setDateFormat(row_popover.end) || '-' }}
                            </a-descriptions-item>
                            <a-descriptions-item>
                              {{ row_popover.timeStart || '-' }}
                            </a-descriptions-item>
                            <a-descriptions-item>
                              {{ row_popover.timeEnd || '-' }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Description">
                              {{ limitTextTask(row_popover.description) || '-' }}
                            </a-descriptions-item>
                          </a-descriptions>
                          <div class="flex justify-between mt-2">
                            <a-button v-if="hasPermission('calendar.event.edit')" type="primary" @click="getOneByCalender(temp_row)">Edit</a-button>
                            <a-button v-if="hasPermission('calendar.event.delete')" type="danger" ghost @click="openDeleteCalender">Delete</a-button>
                          </div>
                        </template>
                      </ASpin>
                    </template>
                    <div class="cv-event flex items-center gap-x-2" :class="classes" :style="{top:top}">
                      <feather-icon icon="CalendarIcon" svg-classes="text-primary w-4 h-4"></feather-icon>
                      {{ title }}
                    </div>
                  </a-popover>
                </template>
              </template>
            </calendar-view>
        </div>
    </ASpin>

    <!--  modal ADD EVENT   -->
    <a-modal centered :title="edit_mode ? 'Edit Event' : 'New Event' " :visible="visibleNewEvent" @cancel="cancelCloseEvent" :width="700">
        <ASpin :spinning="loading" :indicator="indicator">
          <a-form :form="form" @submit.prevent="handleCalender">

          <a-form-item label="Title" has-feedback>
            <a-input
              v-decorator="['title',{ rules: [{ required: true, message: 'this field is required.' }]}]"
              placeholder="Title"
            />
          </a-form-item>

          <div class="grid grid-cols-2 gap-2" :class="[ !is_checked_all_day ? 'md:grid-cols-4' : 'md:grid-cols-2' ]">
            <a-form-item label="Start date" has-feedback>
              <a-date-picker
                v-decorator="['start',{ rules: [
                  { required: true, message: 'this field is required.' },
                  { validator: (rule,value) => validateCheckDateFrom(value,'end'), required:true, message: 'The start date must be smaller than the end date.\n' }
                ]}]"
                class="w-full"
                placeholder="dd/mm/yyyy"
                :format="dateFormat"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>
            <a-form-item label="Start time" has-feedback v-if="!is_checked_all_day">
              <a-time-picker
                class="w-full"
                format="h:mm A"
                valueFormat="HH:mm:ss"
                v-decorator="['time_start',{ rules: [{ required: true, message: 'this field is required.' }] }]"
                @change="selectStart"
              />
            </a-form-item>
            <a-form-item label="End date" has-feedback>
              <a-date-picker
                v-decorator="['end',{ rules: [
                  { required: true, message: 'this field is required.' },
                  { validator: (rule,value) => validateCheckDateTo(value,'start'), required:true , message: 'The end date must be greater than the start date.\n' }
                ]}]"
                class="w-full"
                placeholder="dd/mm/yyyy"
                :format="dateFormat"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>
            <a-form-item has-feedback label="End time" v-show="!is_checked_all_day">
              <a-time-picker
                class="w-full"
                format="h:mm A"
                valueFormat="HH:mm:ss"
                v-decorator="['time_end',{ rules: [{ required: true, message: 'this field is required.' }] }]"
                @change="selectEnd"
              />
            </a-form-item>
          </div>

          <div class="flex space-x-3">
            <a-form-item class="self-end">
              <a-checkbox
                @change="changeCheck"
                v-decorator="['is_all_day',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
              >
                All day
              </a-checkbox>
            </a-form-item>

<!--            :checked="checked"-->

            <a-form-item class="self-end">
              <a-checkbox
                @change="changeRepeat"
                v-decorator="['repeat_allow',{ valuePropName:'checked',rules: [{ required: false}] }]"
              >
                Repeat
              </a-checkbox>
            </a-form-item>
          </div>

          <div class="flex items-center" v-if="edit_mode && row && row.repeat_allow">
            <div class="font-bold">Summery:</div>
            <div class="font-normal ml-1">
                Repeat every
                {{ (form.getFieldValue('repeat_every') || row && row.repeat_every) === 1 ? '' : form.getFieldValue('repeat_every') || row.repeat_every }}
                {{ selectRepeatType(form.getFieldValue('repeat_type') || (row ? row.repeat_type : null)) }}
                {{ days_of_months_repeat(form.getFieldValue('in_repeat_monthly_repeat_on_day_of_month') || (row ? row.in_repeat_monthly_repeat_on_day_of_month : null))}}
                {{ value_type_end(form.getFieldValue('type_end_date') || (row ? row.type_end_date : null)) }}
                <a-button type="link" class="p-0 self-center" @click="RepeatEditEvent(row)">Edit</a-button>
            </div>
          </div>

          <a-form-item label="Location" has-feedback>
            <a-input
              v-decorator="['location',{ rules: [{ required: false, message: 'this field is required.' }] }]"
              placeholder="Location"
            />
          </a-form-item>

          <SelectOption
            url="/account/list/"
            label="Attendees"
            field="for_users"
            :required="true"
            method="get"
            mode="multiple"
            placeholder="Find A User"
            class="w-full"
          />

          <a-form-item class="self-end">
            <a-checkbox
              v-decorator="['is_for_firm',{ valuePropName:'checked', rules: [{ required: false, message: 'this field is required.' }] }]"
            >
              Add this event to the Firm calendar
            </a-checkbox>
          </a-form-item>

          <selectSearch
            :required="false"
            url="/matter/query/"
            :options="optionSearchMatter"
            class="self-center mt-8 md:mt-0 w-full"
            :is_include_matter="true"
            @selectSearch="handleSearch"
          />

          <a-form-item label="Priority" has-feedback>
              <a-select v-decorator="['labels',{ initialValue: 1,rules: [{ required: false }] }]">
                <a-select-option v-for="(label, index) in calendarLabels" :value="label.value">
                  <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                  <span>{{ label.text }}</span>
                </a-select-option>
              </a-select>
          </a-form-item>

          <a-form-item label="Tags" has-feedback>
              <a-select
                mode="tags"
                style="width: 100%"
                placeholder="Enter your tags"
                v-decorator="['tags']"
              >
                <a-select-option v-for="(tag,index) in tags" :key="index">
                  {{ tag }}
                </a-select-option>
              </a-select>
            </a-form-item>

          <a-divider/>

          <RemindersComponent
            ref="reminder"
            @addReminder="addReminder"
            @removeReminder="removeReminder"
            @changeOptionDate="handleChangeDate"
          />
          <a-divider/>

          <a-form-item label="Description" has-feedback>
            <a-textarea
              v-decorator="['description',{ rules: [{ required: false, message: 'Please input your username!' }] }]"/>
          </a-form-item>

          <a-divider/>

          <div class="flex justify-between space-x-2">
            <div class="space-x-2">
              <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
                Save event
              </a-button>
              <a-button type="primary" ghost @click="cancelCloseEvent" style="border-radius: 3px !important;">
                Cancel
              </a-button>
            </div>
            <div>
              <a-button type="danger" @click="openDeleteCalender" v-if="edit_mode" style="border-radius: 3px !important;">
                Delete
              </a-button>
            </div>
          </div>
        </a-form>
        </ASpin>
    </a-modal>

    <!--  modal repeat event  -->
    <a-modal centered title="Repeat this event" :visible="visibleRepeatEvent" @cancel="modeRepeat" :width="700">
      <a-form :form="form">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <a-form-item label="Repeat" has-feedback>
            <a-select
              allowClear
              @select="selectRepeatType"
              class="select"
              v-decorator="['repeat_type',{rules: [{ required: form.getFieldValue('repeat_allow'), message: 'This field is required.' }] }]"
            >
              <a-select-option :value="1">
                Daily
              </a-select-option>
              <a-select-option :value="2">
                Weekly
              </a-select-option>
              <a-select-option :value="3">
                Monthly
              </a-select-option>
              <a-select-option :value="4">
                Yearly
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Every">
            <a-input-number :min="1" v-decorator="['repeat_every',{ initialValue: 1,rules: [{ required: false, message: 'This field is required.' }] }]" style="border-radius: 3px !important;"/>
            {{ selectRepeatType(form.getFieldValue('repeat_type')) || 'Day(s)' }}
          </a-form-item>

          <div v-if="form.getFieldValue('repeat_type') === 3" class="flex">
            <a-form-item class="self-end">
              On
              <a-input-number
                :min="1"
                :max="31"
                v-decorator="['in_repeat_monthly_repeat_on_day_of_month',{ initialValue: row && row.in_repeat_monthly_repeat_on_day_of_month ? row.in_repeat_monthly_repeat_on_day_of_month: null ,rules: [{ required: false, message: 'This field is required.' }] }]" style="border-radius: 3px !important;"
              />
<!--              :max="maxDaysRepeat(form.getFieldValue('start'))"-->
              day(s)
            </a-form-item>
          </div>
<!--          <div v-else-if="form.getFieldValue('repeat_type') === 2">-->
<!--            <a-form-item label="Day of The Week:" class="self-end">-->
<!--              <a-select v-decorator="['labels',{ initialValue: 1,rules: [{ required: false }] }]">-->
<!--                <a-select-option v-for="(label, index) in calendarLabels" :value="label.value">-->
<!--                  <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>-->
<!--                  <span>{{ label.text }}</span>-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </div>-->

        </div>

<!--        <div class="flex justify-center space-x-2 mt-5" v-if="form.getFieldValue('repeat_type') === 2">-->
<!--          <div class="flex space-x-2 mt-5" v-if="false">-->
          <div class="flex space-x-2 mt-5" v-if="form.getFieldValue('repeat_type') === 2">
            <a-form-item class="self-end">
              <a-checkbox
                v-decorator="['in_repeat_weekly_repeat_on_monday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
              >
                Mo
              </a-checkbox>
            </a-form-item>
            <a-form-item class="self-end">
              <a-checkbox
                v-decorator="['in_repeat_weekly_repeat_on_tuesday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
              >
                Tu
              </a-checkbox>
            </a-form-item>
            <a-form-item class="self-end">
              <a-checkbox
                v-decorator="['in_repeat_weekly_repeat_on_wednesday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
              >
                We
              </a-checkbox>
            </a-form-item>
            <a-form-item class="self-end">
              <a-checkbox
                v-decorator="['in_repeat_weekly_repeat_on_thursday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
              >
                Th
              </a-checkbox>
            </a-form-item>
            <a-form-item class="self-end">
              <a-checkbox
                v-decorator="['in_repeat_weekly_repeat_on_friday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
              >
                Fr
              </a-checkbox>
            </a-form-item>
            <a-form-item class="self-end">
              <a-checkbox
                v-decorator="['in_repeat_weekly_repeat_on_saturday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
              >
                Sa
              </a-checkbox>
            </a-form-item>
            <a-form-item class="self-end">
              <a-checkbox
                v-decorator="['in_repeat_weekly_repeat_on_sunday',{ valuePropName:'checked',rules: [{ required: false, message: 'this field is required.' }] }]"
              >
                Su
              </a-checkbox>
            </a-form-item>
        </div>

        <a-divider/>

        <h4>End</h4>

        <div class="flex flex-col items-end md:flex-row ml-16">
          <a-form-item>
            <a-radio-group @change="selectTypeRepeatEnd" class="flex flex-col" v-decorator="['type_end_date',{ initialValue: InitialValueTypeEndDate, rules: [{ required: false, message: 'This field is required.' }] }]">
              <a-radio :style="{display: 'block',height: '40px',lineHeight: '30px'}" :value="1">
                Never
              </a-radio>
              <a-radio :style="{display: 'block',height: '40px',lineHeight: '30px'}" :value="2">
                After
              </a-radio>
              <a-radio :style="{display: 'block',height: '40px',lineHeight: '30px'}" :value="3">
                On
              </a-radio>
            </a-radio-group>
          </a-form-item>

          <div class="flex flex-col">
            <a-form-item class="pb-2">
              (until the end of the year)
            </a-form-item>
            <a-form-item >
              <a-input-number :disabled="form.getFieldValue('type_end_date') !== 2" :min="1" v-decorator="['repeat_end_after_occurrence',{ rules: [{ required: false, message: 'This field is required.' }] }]" style="border-radius: 3px !important;"/>
              occurrence(s)
            </a-form-item>
            <a-form-item>
              <a-date-picker
                :disabled="form.getFieldValue('type_end_date') !== 3"
                v-decorator="['repeat_end_date',{ rules: [{ required: false, message: 'This field is required.' }] }]"
                style="border-radius: 3px !important;"
                :format="dateFormat"
                valueFormat="YYYY-MM-DD[T]HH:mm:ss"
              />
            </a-form-item>
          </div>

        </div>

        <a-divider/>

        <div class="flex">
          <div class="font-bold">Summery:</div>
          <div class="font-normal ml-1">
            Repeat every
            {{ form.getFieldValue('repeat_every') <= 1 ? '' : form.getFieldValue('repeat_every') }}
            {{ selectRepeatType(form.getFieldValue('repeat_type')) }}
            {{ days_of_months_repeat(form.getFieldValue('in_repeat_monthly_repeat_on_day_of_month')) }}
            {{ value_type_end(form.getFieldValue('type_end_date')) }}
          </div>
        </div>

        <a-divider/>

        <div class="flex justify-between space-x-2">
          <div class="space-x-2">
            <a-button type="primary" @click="repeatContinue" style="border-radius: 3px !important;">
              Save
            </a-button>
            <a-button type="primary" ghost @click="modeRepeat" style="border-radius: 3px !important;">
              Cancel
            </a-button>
          </div>
        </div>
      </a-form>
    </a-modal>

    <vs-prompt
      color="danger"
      title="Delete Calender"
      @cancel="delete_calender = false"
      @close="delete_calender = false"
      :active.sync="delete_calender"
      buttons-hidden
    >
      <div class="text-left">
        <div class="font-medium">Are you sure to delete this calender item ?</div>
      </div>
      <div class="flex justify-center space-x-3 mt-5">
        <vs-button color="danger" @click="removeCalenderItem">Delete</vs-button>
        <vs-button color="danger" type="flat" @click="delete_calender = false">Cancel</vs-button>
      </div>
    </vs-prompt>

    <TaskListModal
      v-model="showTaskListModal"
      :date="taskListDate"
    />
  </div>
</template>

<script>
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
import moduleCalendar from '@/store/calendar/moduleCalendar.js'
import moment from 'moment';
import mixins from '@/views/mixin/mixin'
require('vue-simple-calendar/static/css/default.css')

import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'
import axios from '@/axios'
import mixin from '../mixin/mixin'
import SelectOption from "../forms/SelectOptionSingle"
import selectSearch from "@/views/forms/selectSearch";
import Template from "@/views/template/Template";
import RemindersComponent from "@/views/reminders/RemindersComponent";
import TaskListModal from './TaskListModal';

export default {
  components: {
    RemindersComponent,
    Template,
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    SelectOption,
    selectSearch,
    TaskListModal,
  },
  mixins:[mixin],
  data() {
    return {
      showDate    : new Date(),
      disabledFrom: false,
      id          : 0,
      title       : '',
      startDate   : '',
      endDate     : '',
      labelLocal  : 'none',
      langHe      : he,
      langEn      : en,
      url         : '',
      calendarView         : 'month',
      activePromptAddEvent : false,
      activePromptEditEvent: false,
      calendarViewTypes: [
        {
          label: 'Month',
          val: 'month'
        },
        {
          label: 'Week',
          val: 'week'
        },
        {
          label: 'Year',
          val: 'year'
        }
      ],
      // variable myself
      calenders         : [],
      tags              : [],
      reminders         : [],
      visibleNewEvent   : false,
      is_checked_all_day: false,
      delete_calender   : false,
      edit_mode         : false,
      visibleRepeatEvent: false,
      temp_row          : undefined,
      row               : undefined,
      time_start        : null,
      time_end          : null,
      checked           : false,
      loading           : false,
      loading_popover   : false,
      start_date        : null,
      end_date          : null,
      row_popover       : null,
      calendarLabels    : [
        { value: 4, text: 'Urgent' , color: 'danger'  },
        { value: 3, text: 'High'   , color: 'warning' },
        { value: 1, text: 'Normal' , color: 'primary' },
        { value: 2, text: 'Low'    , color: 'success' },
      ],
      indicator         : <a-icon type="loading" style="font-size: 36px" spin />,
      calendarFilter: 'events', // It's value can be one of 'events', 'tasks', or 'both'
      showTaskListModal: false,
      taskListDate: undefined,
    }
  },
  computed: {
    simpleCalendarEvents () {
      return this.$store.state.calendar.events
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    InitialValueTypeEndDate(){
      if(this.edit_mode){
        if(this.form.getFieldValue('repeat_end_date') || (this.row && this.row.repeat_end_date))
          return 3
        else if(this.form.getFieldValue('repeat_end_after_occurrence') || (this.row && this.row.repeat_end_after_occurrence))
          return 2
        else
          return 1
      }
      return 1
    },
  },
  methods: {
    //  methods myself
    eventDragged() {

    },
    addReminder(){
      if (this.form.getFieldValue('start'))
        this.$refs.reminder.reminders.push({ target_date: undefined,notification_type: undefined })
      else this.$message.error('Please enter field start date.')
    },

    removeReminder(ind){
      const { form } = this;
      const reminders = form.getFieldValue('reminders')
      form.setFieldsValue({
        reminders: reminders.filter((reminder,index) => index !== ind)
      });
      this.$refs.reminder.reminders.splice(ind,1)
    },

    handleChangeDate(date,i) {
      const start = this.form.getFieldValue('start')
      if (start) {
        this.form.setFieldsValue({ [`reminders[${i}].target_date`]: moment(start).subtract(date, 'days').format('YYYY-MM-DD[T]HH:mm:ss') })
      }
    },

    periodChangedCallback(date){
      this.start_date = moment(date.periodStart).format('YYYY-MM-DD[T]HH:mm:ss')
      this.end_date   = moment(date.periodEnd).format('YYYY-MM-DD[T]HH:mm:ss')
    },

    maxDaysRepeat(date){
      if(this.edit_mode)
        return moment(date).endOf('month').format('DD')
      else
        return Number(moment(this.showDate.toISOString()).endOf('month').format('DD'))
    },

    days_of_months_repeat(val){
      const {row} = this
      if((this.form.getFieldValue('repeat_type') || row && row.repeat_type) === 3){
        if(val){
          const date = `${moment(this.showDate.toISOString()).format('YYYY')}-${moment(this.showDate.toISOString()).format('MM')}-${val < 10 ? '0' + val : val}`
          return `on the ${moment(date).format('Do')}` || ''
        }else if(val === null || val === ''){
          return ``
        }else if(row && row.in_repeat_monthly_repeat_on_day_of_month){
          const date = `${moment(this.form.getFieldValue('start')).format('YYYY')}-${moment(this.form.getFieldValue('start')).format('MM')}-${row.in_repeat_monthly_repeat_on_day_of_month < 10 ? '0' + row.in_repeat_monthly_repeat_on_day_of_month : row.in_repeat_monthly_repeat_on_day_of_month}`
          return `on the ${moment(date).format('Do')}` || ''
        }
      }
    },

    value_type_end(value){
      const {row} = this
      const field_or_row = this.form.getFieldValue('repeat_end_date') || row && row.repeat_end_date
      if(value === 2)
        return `for ${this.form.getFieldValue('repeat_end_after_occurrence') || row && row.repeat_end_after_occurrence} times`
      if(value === 3)
        return field_or_row ? `until ${moment(field_or_row).format('MMMM Do YYYY')}` : undefined
    },

    labelColor (label) {
        const valueLabel = Number(label)
        if      (valueLabel === 1) return 'primary text-primary'
        else if (valueLabel === 2) return 'success text-success'
        else if (valueLabel === 3) return 'warning text-warning'
        else if (valueLabel === 4) return 'danger text-danger'
        else if (valueLabel === 5) return 'dark text-dark'
        else if (valueLabel === -1) return 'purple' // This is the color used for tasks
        else return 'primary'
    },

    selectTypeRepeatEnd({target:{value}}){
      let { row } = this
      if(value === 1)
        this.form.setFieldsValue({repeat_end_after_occurrence: null, repeat_end_date: null})
      else if(value === 2)
        this.form.setFieldsValue({repeat_end_date: null,repeat_end_after_occurrence: row && row.repeat_end_after_occurrence ? row.repeat_end_after_occurrence : 1})
      else
        this.form.setFieldsValue({repeat_end_after_occurrence: null,repeat_end_date: row && row.repeat_end_date ? row.repeat_end_date : moment().format('YYYY-MM-DD')})
    },

    dateOffsetByMonths(months, dateStr, format) {
      let startDate = moment(dateStr, format);
      return Array.from(Array(months).keys()).reduce(function(res, n, i) {
        let date = startDate.clone();
        date.add(i, 'weeks');
        res.push(date.format('YYYY-MM-DD'));
        return res;
      }, []);
    },

    RepeatEditEvent(row){
      this.visibleRepeatEvent = true
      if(this.edit_mode && row){
        this.$nextTick(() => this.form.setFieldsValue({
          repeat_end_date               : this.form.getFieldValue('repeat_end_date')  || row.repeat_end_date,
          repeat_every                  : this.form.getFieldValue('repeat_every')     || row.repeat_every,
          repeat_type                   : this.form.getFieldValue('repeat_type')      || row.repeat_type,
          repeat_end_after_occurrence   : this.form.getFieldValue('repeat_end_after_occurrence') || row.repeat_end_after_occurrence,
          in_repeat_weekly_repeat_on_monday : this.form.getFieldValue('in_repeat_weekly_repeat_on_monday') || row.in_repeat_weekly_repeat_on_monday,
          in_repeat_weekly_repeat_on_tuesday : this.form.getFieldValue('in_repeat_weekly_repeat_on_tuesday') || row.in_repeat_weekly_repeat_on_tuesday,
          in_repeat_weekly_repeat_on_wednesday : this.form.getFieldValue('in_repeat_weekly_repeat_on_wednesday') || row.in_repeat_weekly_repeat_on_wednesday,
          in_repeat_weekly_repeat_on_thursday : this.form.getFieldValue('in_repeat_weekly_repeat_on_thursday') || row.in_repeat_weekly_repeat_on_thursday,
          in_repeat_weekly_repeat_on_friday : this.form.getFieldValue('in_repeat_weekly_repeat_on_friday') || row.in_repeat_weekly_repeat_on_friday,
          in_repeat_weekly_repeat_on_saturday : this.form.getFieldValue('in_repeat_weekly_repeat_on_monday') || row.in_repeat_weekly_repeat_on_saturday,
          in_repeat_weekly_repeat_on_sunday : this.form.getFieldValue('in_repeat_weekly_repeat_on_sunday') || row.in_repeat_weekly_repeat_on_sunday,
        }))
      }
    },

    changeRepeat({ target:{checked} }){
      this.checked = checked
      const {row} = this
      if(checked){
        this.RepeatEditEvent(row)
      }else
        this.visibleRepeatEvent = false
    },

    repeatContinue(){
        if(!this.form.getFieldValue('repeat_type')){
          this.$message.error('field Repeat is required.')
          return
        }
        if(!this.form.getFieldValue('repeat_every')){
          this.$message.error('field Repeat every is required.')
          return
        }
        this.visibleRepeatEvent = false
    },

    modeRepeat(){
      this.visibleRepeatEvent = false;
    },

    selectRepeatType(value){
      if(value === 1)
        return 'Day(s)'
      else if(value === 2)
        return 'Week(s)'
      else if(value === 3)
        return 'Month(s)'
      else if(value === 4)
        return 'Year(s)'
    },

    selectStart(time, timeString){
      this.time_start = timeString
    },

    selectEnd(time, timeString){
      this.time_end = timeString
    },

    openDeleteCalender(){
      this.delete_calender = true
    },

    async removeCalenderItem(){
      try{
        this.loading = true
        await axios.delete(`/calendar/event/${this.temp_row}/`)
        this.form.resetFields()
        this.delete_calender = false
        this.visibleNewEvent = false
        this.$notification['success']({
          message: 'Success',
          description: `Calender item deleted.`,
        })
        await this.setUpdateCalender()
      }catch (e){
        this.delete_calender = true
        this.visibleNewEvent = true
        this.$notification['error']({
          message: 'error',
          description: `Calender item failed.`,
        })
      } finally {
        this.loading = false
      }
    },

    async getOneByCalender(id){
      try{
        this.loading_popover = true
        const {data}    = await axios.get(`/calendar/event/${id}/`)
        this.visibleNewEvent = true
        const start     = data.start.split('T')
        const end       = data.end.split('T')
        data.for_users  = data.for_users.map(item=>item.id)
        data.matter ? data.matter = data.matter.title : data.matter = undefined
        data.time_start = start[start.length - 1]
        data.time_end   = end[end.length - 1]
        data.repeat_type !== -1 ? data.repeat_allow = true : data.repeat_allow = false
        if(data.repeat_type === -1) data.repeat_type = undefined
        data.is_all_day === true ? this.is_checked_all_day = true : this.is_checked_all_day = false
        data.labels = data.labels ? Number(`${data.labels}`) : 1
        data.tags   = data.tags !== '[]' && data.tags ? data.tags.slice(1, -1).split(',').map(item=>item.replace(/['"]+/g, '')) : []
        data.repeat_end_after_occurrence ? data.type_end_date = 2 : data.repeat_end_date ? data.type_end_date = 3 : data.type_end_date = 1
        if (data.reminders && data.reminders.length)
          this.$refs.reminder.reminders = data.reminders.map(item=>({ target_date: item.target_date, notification_type: item.notification_type }))
        this.row = data
        this.$nextTick(()=>this.form.setFieldsValue(data))
      }catch (e) {
        this.$notification['error']({
          message: 'error',
          description: `Calender item failed.`,
        })
      }finally {
        this.loading_popover = false
      }
    },

    handleVisibilityChange(visibility,id) {
      if (this.hasPermission('calendar.event.get')) {
        if ((this.calendarFilter === 'events' || this.calendarFilter === 'both') && visibility) {
          this.edit_mode = true
          this.temp_row = id
          this.getOneByEvent(id)
        } else {
          throw new Error(`Invalid calendarFilter value "${this.calendarFilter}"`)
        }
      }
    },

    async getOneByEvent(id){
      try{
        this.row_popover = null
        this.loading_popover = true
        const {data} = await axios.get(`/calendar/event/${id}/`)
        this.row = data
        this.row_popover = {
          start : moment(data.start).format('YYYY/MM/DD'),
          end   : moment(data.end).format('YYYY/MM/DD'),
          timeStart: moment(data.start).format('HH:mm'),
          timeEnd: moment(data.end).format('HH:mm'),
          title : data.title,
          label: data.labels,
          description: data.description
        }
      }catch (e) {
        this.$message.error('Error receiving data')
      }finally {
        this.loading_popover = false
      }
    },

    async fetchCalendar(){
      try{
        this.loading  = true
        const start   = moment(this.showDate ? this.showDate.toISOString() : new Date().toISOString()).startOf('month').format('YYYY-MM-DD[T]HH:mm:ss')
        const end     = moment(this.showDate ? this.showDate.toISOString() : new Date().toISOString()).endOf('month').format('YYYY-MM-DD[T]HH:mm:ss')
        const {data}  = await axios.post('/calendar/data/',{ start, end })
        const repeats = { 1: 'days', 2: 'weeks', 3: 'months', 4: 'years' }

        // This implementation supports displaying both tasks and events at the
        // same, but right now, only one of them is required, hence the
        // implementation hasn't been changed to a more suitable one, in case
        // we want to revert back to the previous UX.
        let calendar_tasks  = []
        let calendar_events = []

        if (this.calendarFilter === 'both' || this.calendarFilter === 'events') {
          calendar_events = data.events.map(calender => {
            if (calender.repeat_type === -1)
              return {
                id: calender.id,
                title: calender.title,
                startDate: calender.start,
                endDate: calender.end,
                classes: this.labelColor(calender.labels),
                itemType: 'event',
              }
            else
              return this.getDateList(calender, repeats[calender.repeat_type], start, end)
          })
        }

        if (this.calendarFilter === 'both' || this.calendarFilter === 'tasks') {
          calendar_tasks = data.tasks.map(calender => {
            return {
              id: calender.id,
              title: calender.title,
              startDate: calender.due_date,
              endDate: calender.due_date,
              classes: this.labelColor(-1),
              itemType: 'task',
            }
          })
        }

        const calendar_records = calendar_events.concat(calendar_tasks)
        const date = calendar_records.reduce((prev, next)=> prev.concat(next),[]) // flatten the calender_records array
        this.calenders = date
      } catch (e) {
        this.$notification['error']({
          message: 'error',
          description: `No connection to the server.`,
        });
      } finally {
        this.loading = false
      }
    },

    /**
    ** Returns the weekdays that the calendar event must be repeated at.
    ** If the repeat type isn't weekly, or a particular weekday isn't selected, returns an empty list
    **
    ** @returns {Array} an array of numbers, where 1 means Monday and 7 means Sunday
    **/
    getWeekdaysOfWeeklyRepeat(calendar) {
      if (calendar.repeat_type !== 2) return []
      const result = []
      if (calendar.in_repeat_weekly_repeat_on_monday) result.push(1)
      if (calendar.in_repeat_weekly_repeat_on_tuesday) result.push(2)
      if (calendar.in_repeat_weekly_repeat_on_wednesday) result.push(3)
      if (calendar.in_repeat_weekly_repeat_on_thursday) result.push(4)
      if (calendar.in_repeat_weekly_repeat_on_friday) result.push(5)
      if (calendar.in_repeat_weekly_repeat_on_saturday) result.push(6)
      if (calendar.in_repeat_weekly_repeat_on_sunday) result.push(7)
      return result
    },

    /**
    ** Returns the dates of the repeated calendar events.
    **
    ** @parameter {Object} calendar
    ** the calendar event that is being processed
    ** data format is whatever is directly coming from the server, without change
    **
    ** @parameter {String} current
    ** is the repeat type of the event, can be one of 'days', 'weeks', 'months', 'years'
    ** if its value is undefined, it's a bug that must be handled in fetchCalendar()
    */
    getDateList(calender, current, start, end) {
      const calendarEventRepeatTypes = { daily: 1, weekly: 2, monthly: 3, yearly: 4 }

      const daily     = [] // the result that will be returned, an array of calender event objects
      let repeatDaily = [] // an array of date strings (in the YYYY-MM-DD format)

      let startingMoment = moment(calender.start)
      repeatDaily.push(startingMoment.format('YYYY-MM-DD[T]HH:mm:ss'))
      startingMoment.add(current !== 'days' ? diffDate : 0, 'days')
      repeatDaily.push(startingMoment.format('YYYY-MM-DD[T]HH:mm:ss'))
      if (calender.repeat_type === calendarEventRepeatTypes.monthly &&
        calender.in_repeat_monthly_repeat_on_day_of_month
      ) {
        while (startingMoment.daysInMonth() < calender.in_repeat_monthly_repeat_on_day_of_month) {
          startingMoment.add(1, 'months')
        }
        const tmp = `${startingMoment.format('YYYY')}-${startingMoment.format('MM')}-${calender.in_repeat_monthly_repeat_on_day_of_month < 10 ? '0'+calender.in_repeat_monthly_repeat_on_day_of_month:calender.in_repeat_monthly_repeat_on_day_of_month}`
        startingMoment = moment(tmp)
      }

      let endDate       = moment(calender.end)
      let endDateRepeat = calender.repeat_end_date ? moment(calender.repeat_end_date) : null
      const diffDate    = endDate.diff(moment(calender.start), 'days') // the number of days between the calender event's start and date dates

      // const start_repeat_days_of_monthly = moment(calender.start)
      // if(calender.in_repeat_monthly_repeat_on_day_of_month){
      //   repeatDaily.push(start_repeat_days_of_monthly.format('YYYY-MM-DD[T]HH:mm:ss'))
      //   start_repeat_days_of_monthly.add(0, 'days');
      //   repeatDaily.push(start_repeat_days_of_monthly.format('YYYY-MM-DD[T]HH:mm:ss'))
      //   start_repeat_days_of_monthly.add(calender.repeat_every, current);
      // }

      // Helper function to push the dates & times in to the repeatDaily result array.
      const pushCalendarEventDateTimes = () => {
        if (!(calender.repeat_type === calendarEventRepeatTypes.monthly &&
          calender.in_repeat_monthly_repeat_on_day_of_month > startingMoment.daysInMonth()) &&
          moment(startingMoment.format('YYYY-MM-DD')).isSameOrAfter(moment(calender.start).format('YYYY-MM-DD')) &&
          !moment(startingMoment.format('YYYY-MM-DD')).isSame(moment(calender.start).format('YYYY-MM-DD'))
        ) {
          if (calender.in_repeat_monthly_repeat_on_day_of_month >= 28) {
            const d = moment(startingMoment).format('YYYY-MM')
            const a = `${d}-${calender.in_repeat_monthly_repeat_on_day_of_month}`
            repeatDaily.push(moment(a).format('YYYY-MM-DD[T]HH:mm:ss'))
            moment(a).add(calender.repeat_every, 'month')
            repeatDaily.push(moment(a).format('YYYY-MM-DD[T]HH:mm:ss'))
          } else if (this.getWeekdaysOfWeeklyRepeat(calender).length > 0) {
            for (let weekday of this.getWeekdaysOfWeeklyRepeat(calender)) {
              startingMoment.isoWeekday(weekday)
              if (startingMoment >= moment(calender.start)) {
                repeatDaily.push(startingMoment.format('YYYY-MM-DD[T]HH:mm:ss'))
                startingMoment.add(current !== 'days' ? diffDate : 0, 'days')
                repeatDaily.push(startingMoment.format('YYYY-MM-DD[T]HH:mm:ss'))
              }
            }
          } else {
            repeatDaily.push(startingMoment.format('YYYY-MM-DD[T]HH:mm:ss'))
            startingMoment.add(current !== 'days' ? diffDate : 0, 'days')
            repeatDaily.push(startingMoment.format('YYYY-MM-DD[T]HH:mm:ss'))
          }
          if (calender.in_repeat_monthly_repeat_on_day_of_month || current !== 'days') {
            startingMoment.subtract(diffDate, 'days')
          }
        }
        startingMoment.add(calender.repeat_every, current)
      }

      if (!endDateRepeat && !calender.repeat_end_after_occurrence) {
        // Never end.
        while (startingMoment <= moment(calender.start).endOf('year')) {
          pushCalendarEventDateTimes()
        }
      } else if(endDateRepeat) {
        // End Date.
        while(startingMoment <= endDateRepeat) {
          pushCalendarEventDateTimes()
        }
      } else {
        // End Occurrence.
        for (let c = 0; c < calender.repeat_end_after_occurrence; c++) {
          pushCalendarEventDateTimes()
        }
      }

      for(let i = 0 ; i <= repeatDaily.length; i += 2)
        daily.push({
          id: calender.id,
          title: calender.title,
          startDate: repeatDaily[i],
          endDate: repeatDaily[i],
          classes: this.labelColor(calender.labels),
          itemType: 'event',
        })
      return daily
    },

    cancelCloseEvent(){
      this.visibleNewEvent    = false
      this.is_checked_all_day = false
      if(this.edit_mode){
        this.form.resetFields()
        this.row = undefined
      }
    },

    showTaskList(date) {
      this.taskListDate = moment(date).format('YYYY-MM-DD')
      this.showTaskListModal = true
    },

    onCalendarCellClicked(e) {
      if (this.calendarFilter === 'events' || this.calendarFilter === 'both') this.openAddNewEvent(e)
      else if (this.calendarFilter === 'tasks') this.showTaskList(e)
    },

    openAddNewEvent (date) {
      if (this.hasPermission('calendar.event.create')) {
        this.edit_mode = false
        this.visibleNewEvent = true
        this.is_checked_all_day = false
        let now = new moment();
        this.form.resetFields()
        this.$nextTick(()=>this.form.setFieldsValue({
          start      : moment(date).format('YYYY-MM-DD'),
          end        : moment(date).format('YYYY-MM-DD'),
          time_start : now.format('HH:mm:ss'),
          time_end   : now.add(1, 'hours').format('HH:mm:ss'),
        }))
      }
    },

    changeCheck({ target:{ checked } }){
      this.is_checked_all_day = checked
    },

    handleCalender(){
      this.form.validateFields(async(err,values)=>{
        if(!err){
          try{
            this.loading = true

            values.in_repeat_weekly_repeat_on_monday    = values.in_repeat_weekly_repeat_on_monday    || false
            values.in_repeat_weekly_repeat_on_tuesday   = values.in_repeat_weekly_repeat_on_tuesday   || false
            values.in_repeat_weekly_repeat_on_wednesday = values.in_repeat_weekly_repeat_on_wednesday || false
            values.in_repeat_weekly_repeat_on_thursday  = values.in_repeat_weekly_repeat_on_thursday  || false
            values.in_repeat_weekly_repeat_on_friday    = values.in_repeat_weekly_repeat_on_friday    || false
            values.in_repeat_weekly_repeat_on_saturday  = values.in_repeat_weekly_repeat_on_saturday  || false
            values.in_repeat_weekly_repeat_on_sunday    = values.in_repeat_weekly_repeat_on_sunday    || false

            values.repeat_allow  = undefined
            values.type_end_date = undefined
            values.repeat_end_date = values.repeat_end_date ? moment(values.repeat_end_date).format('YYYY-MM-DD[T]HH:mm:ss') : null
            if(values.reminders && values.reminders.length)
              values.reminders = values.reminders.filter(reminder => reminder.notification_type !== undefined && reminder.target_date !== undefined).map((item) =>({notification_type: item.notification_type, target_date: item.target_date}))
            if(this.edit_mode){
              if(!this.is_checked_all_day){
                values.start = `${values.start.slice(0,10)}T${this.time_start ? this.time_start : values.time_start}`
                values.end   = `${values.end.slice(0,10)}T${this.time_start ? this.time_end : values.time_end}`
              }else{
                const start  = moment(new Date(values.start)).format('YYYY-MM-DD[T]HH:mm:ss')
                const end    = moment(new Date(values.end)).format('YYYY-MM-DD[T]HH:mm:ss')
                values.start = start
                values.end   = end
              }
              values.time_start = undefined
              values.time_end = undefined
              this.matter_value ? values.matter = this.matter_value : !values.matter ? values.matter = null : values.matter = this.row.matter.id
              if(values.repeat_type && values.repeat_type !== 3)
                values.in_repeat_monthly_repeat_on_day_of_month = null
              await axios.put(`/calendar/event/${this.temp_row}/`,values)
            } else{
              if(!this.is_checked_all_day){
                values.start = `${values.start}T${values.time_start}`
                values.end   = `${values.end}T${values.time_end}`
              }else{
                const start  = moment(new Date(values.start)).format('YYYY-MM-DD[T]HH:mm:ss')
                const end    = moment(new Date(values.end)).format('YYYY-MM-DD[T]HH:mm:ss')
                values.start = start
                values.end   = end
              }
              values.time_start = undefined
              values.time_end = undefined
              await axios.post('/calendar/event/',values)
            }
            this.visibleNewEvent = false
            this.form.resetFields()
            this.is_checked_all_day = false
            await this.setUpdateCalender()
            this.$notification['success']({
              message: 'Success',
              description: `Calender ${this.edit_mode ? 'updated' :'created'}.`,
            });
          }catch (e) {
            this.$notification['error']({
              message: 'error',
              description: `Calender failed.`,
            });
            this.visibleNewEvent = true
          }finally {
            this.loading = false
          }
        }
      })
    },

    updateMonth (val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val)
      //console.log(moment(this.showDate).endOf('month').format('DD'),'this.showDate this.showDate this.showDate')
      this.calenders = []
      this.setUpdateCalender()
    },

    async setUpdateCalender(){
      await this.fetchCalendar()
    },

    clearFields () {
      this.title = this.endDate = this.url = ''
      this.id = 0
      this.labelLocal = 'orange'
    },

    onSelectedDateChanged(date) {
      this.showDate = date
      this.calenders = []
      this.setUpdateCalender()
    },
  },

  created () {
    this.fetchCalendar()
    this.$store.registerModule('calendar', moduleCalendar)
  },

  beforeDestroy () {
    this.$store.unregisterModule('calendar')
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
@import "../style/style.css";

#simple-calendar-app .theme-default .cv-day.today .cv-day-number {
  display: inline-table;
  color: #fff;
  font-weight: 600;
  min-width: 2rem;
  min-height: 2rem;
  height: 0;
}
.theme-default .cv-event{
  //background: #3A3DBE !important;
}
.cv-day{
  cursor: pointer !important;
}
.theme-default .cv-event{
  //border-radius: 3px !important;
}
#simple-calendar-app .theme-default .cv-day.today .cv-day-number{
  border-radius: 3px !important;
}
.ant-btn {
  border-radius: 3px;
}
.cv-event {
  width: calc(14.28571% - 1.05em)
}
.popover-event .ant-popover-title {
  padding: 0;
}

.theme-default .cv-event.purple {
  background-color: #a36dd51f;
  color: #a36dd5 !important;
  border-color: #e7d7f7;
}
.theme-default .cv-event.purple svg { stroke: #a36dd5; }
.theme-default .cv-event.primary svg { stroke: #7367f0; }
.theme-default .cv-event.danger svg { stroke: #ea5455; }
.theme-default .cv-event.warning svg { stroke: #ff9f43; }
.theme-default .cv-event.success svg { stroke: #28c76f; }

.fix-padding-trick { padding-top: 0.2rem; }
@media (min-width: 1200px) { .fix-padding-trick { padding-top: 0.15rem; } }
</style>
